import { useState, useCallback, useEffect } from "react";

function getCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function setCookie(name: string, value: string, days = 365) {
  if (typeof document === "undefined") return;
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires};path=/`;
}

export function useLightingPreset() {
  const [envPreset, setEnvPresetState] = useState<string>("studio");

  useEffect(() => {
    const saved = getCookie("lighting_preset");
    if (saved) setEnvPresetState(saved);
  }, []);

  const setEnvPreset = useCallback((preset: string) => {
    setEnvPresetState(preset);
    setCookie("lighting_preset", preset);
  }, []);

  const togglePreset = useCallback(() => {
    setEnvPreset(envPreset === "studio" ? "night" : "studio");
  }, [envPreset, setEnvPreset]);

  return { envPreset, setEnvPreset, togglePreset };
}